import React from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppBottomNav from "@/components/app/AppBottomNav";

/**
 * Layout for the PWA. Bottom nav + content area, requires public auth.
 */
export function AppLayout() {
    const { user } = useAuth();
    const loc = useLocation();
    if (user === null) {
        return (
            <div className="flex h-screen items-center justify-center bg-md-bg text-md-text-2">
                <div className="animate-pulse text-sm">Chargement…</div>
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" replace state={{ from: loc }} />;
    }
    return (
        <div className="flex min-h-screen flex-col bg-md-bg">
            <main className="mx-auto flex w-full max-w-md flex-1 flex-col">
                <Outlet />
            </main>
            <div className="mx-auto w-full max-w-md">
                <AppBottomNav user={user} />
            </div>
        </div>
    );
}

export default AppLayout;
